<p-toast></p-toast>
<div *ngIf="supervisor" class="container-ficha">
    <p-accordion [activeIndex]="0">
        <p-accordionTab header="Supervisor Perfil">
            <section *ngIf="supervisor">
                <div class="formgrid grid">
                    <div class="field col-12 md:col-4">
                        <label for="serie">Nombre </label>
                        <article
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                            {{supervisor.nom_supervisor | uppercase}}</article>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label for="serie">Telefono Movil </label>
                        <article
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                            {{supervisor.telefonoMovil ? supervisor.telefonoMovil : 'Sin información' }}
                        </article>
                    </div>
                    <div class="field col-12 md:col-4"></div>
                    <div class="field col-12 md:col-4">
                        <label for="serie">Usuario</label>
                        <article
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                            {{supervisor.usuario.usuario }}</article>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label for="serie">Contrasena</label>
                        <article
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                            {{supervisor.usuario.contrasenia }}</article>
                    </div>
                </div>
            </section>
        </p-accordionTab>
        <p-accordionTab header="Enfermeras">
            <section *ngIf="supervisor">
                <p-table [value]="supervisor.enfermeras" [tableStyle]="{ 'min-width': '50rem' }">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Enfermera</th>
                            <th>Teléfono Movil</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-enfermera>
                        <tr>
                            <td> <a
                                    [routerLink]="['/administrador/enfermera', enfermera.id]">{{enfermera.nom_enfermera}}</a>
                            </td>
                            <td>{{enfermera.telefonoMovil}}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td colspan="2" class="text-center p-4">
                                <div class="flex flex-column align-items-center">
                                    <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                                    <span class="text-600 mt-2">No se encontraron enfermeras</span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>

                </p-table>
            </section>
        </p-accordionTab>
        <p-accordionTab header="Casos Clínicos">
            <section *ngIf="supervisor">
                <p-toolbar styleClass="mb-4 gap-2">
                    <ng-template pTemplate="left">
                        <form id="sup-productividad-add-frm" [formGroup]="productividadSupervisorForm">
                            <div class="formgrid grid">
                                <div class="field col">
                                    <p-calendar id="fechainicio" formControlName="fechaInicio" dateFormat="dd/mm/yy"
                                        placeholder="Ingrese la fecha inicial" class="w-full" />
                                </div>
                                <div class="field col">
                                    <p-calendar id="fechafin" formControlName="fechaFin" dateFormat="dd/mm/yy"
                                        placeholder="Ingrese la fecha final" class="w-full" />
                                </div>
                            </div>
                        </form>

                    </ng-template>

                    <ng-template pTemplate="right">
                        <button form="sup-productividad-add-frm" pButton pRipple label="Reporte de productividad"
                            icon="pi pi-file" class="mr-2 inline-block" (click)="exportPDF()"
                            [disabled]="productividadSupervisorForm.invalid"></button>
                        <button pButton pRipple [label]="'Excel'" icon="pi pi-file-excel" class="p-button-success"
                            (click)="exportExcel()"></button>
                    </ng-template>
                </p-toolbar>
                <p-table [value]="casosClinicos" [tableStyle]="{ 'min-width': '50rem', 'font-size': '12px' }" styleClass="p-datatable-sm">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Fecha</th>
                            <th>Caso clínico</th>                            
                            <th>Parte cuerpo</th>
                            <th>Hospital</th>
                            <th>Medico</th>
                            <th>Enfermera</th>
                            <th>Productos / Documentos</th>
                            <th>Status</th>
                            <th>Puntos</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-casoclinico>
                        <tr>
                            <td >{{casoclinico.fecha | date:'dd/MM/yyyy'}}</td>
                            <td> <a
                                    [routerLink]="['/administrador/casoclinico', casoclinico.id]">{{casoclinico.serie}}</a>
                            </td>                            
                            <td>{{casoclinico.nomCuerpo}}</td>
                            <td>{{casoclinico.nomHospital}}</td>
                            <td>{{casoclinico.medico.nom_medico | uppercase}}</td>
                            <td>{{casoclinico.enfermera.nom_enfermera | uppercase}}</td>
                            <td>{{casoclinico.productos?.length}}/{{casoclinico.documentos?.length}} </td>
                            <td><span [ngClass]="{'solicitud': casoclinico.status_canje_supervisor === 1,
                                                'enproceso': casoclinico.status_canje_supervisor === 2, 
                                                'procesado': casoclinico.status_canje_supervisor === 3, 
                                                'cancelado': casoclinico.status_canje_supervisor === 4}">
                                    {{getCanje(casoclinico.status_canje_supervisor)}}</span></td>
                            <td> <span
                                    *ngIf="casoclinico.status_canje_supervisor==0 || casoclinico.status_canje_supervisor==1 || casoclinico.status_canje_supervisor==2; else ccpuntos">
                                    <a href="javascript:void(0)"
                                        (click)="asignarpuntos(casoclinico)">{{casoclinico.s_puntos}}</a>
                                </span>
                                <ng-template #ccpuntos>
                                    <span>{{casoclinico.s_puntos}}</span>
                                </ng-template></td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td colspan="7" class="text-center p-4">
                                <div class="flex flex-column align-items-center">
                                    <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                                    <span class="text-600 mt-2">No se encontraron casos clínicos</span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            No. Registros: {{totalItemsCasosClinicos}}, Total paginas {{totalPaginasCasosClinicos}}
                        </div>
                    </ng-template>
                </p-table>
                <div class="card flex justify-content-center">
                    <p-paginator (onPageChange)="onPageChangeCasosClinicos($event)"
                        [first]="currentPageCasosClinicos.first" [rows]="currentPageCasosClinicos.rows"
                        [totalRecords]="totalItemsCasosClinicos"></p-paginator>
                </div>

                <!-- Modal de confirmación -->
                <div class="modal" *ngIf="showModal">
                    <div class="modal-content">
                        <section>
                            <h4 style="text-align: center;">Asignacion de puntos</h4>
                            <form id="catalogo" [formGroup]="puntosForm" (submit)="onSubmit()">
                                <div class="flex justify-content-center gap-3 pt-5">

                                    <p-dropdown [options]="catalogoPuntos"  optionLabel="puntos" [filter]="false"
                                        [showClear]="true" formControlName="puntos" [emptyMessage]="'Sin registros'"
                                        [emptyFilterMessage]="'Sin resultados'" autoWidth="false"  [style]="{'width':'100%'}"
                                        placeholder="Seleccione una cantidad de puntos"></p-dropdown>

                                </div>
                            </form>
                        </section>

                        <div class="modal-buttons">
                            <button type="submit" form="catalogo" [disabled]="!puntosForm.valid"
                                class="btn-confirm">Confirmar</button>
                            <button type="button" (click)="cancelarAccion()" class="btn-cancel">Cancelar</button>
                        </div>
                    </div>
                </div>
            </section>
        </p-accordionTab>
        <p-accordionTab header="Canjes">
            <section *ngIf="supervisor">
                <p-table [value]="canjes" [tableStyle]="{ 'min-width': '50rem' }">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Fecha Solicitud</th>
                            <th>Cantidad</th>
                            <th>Status</th>
                            <th colspan="2">Acciones</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-canje>
                        <tr>
                            <td>{{canje.fechaInicio | date:'dd/MM/yyyy'}}</td>
                            <td>{{canje.redimir}}</td>
                            <td><span
                                    [ngClass]="{'solicitud': canje.status === 1,'rechazado': canje.status === 2, 'procesado': canje.status === 3, 'cancelado': canje.status === 4}">{{getCanje(canje.status)}}
                                </span>
                            </td>
                            <td>
                                <a *ngIf="(canje.status === 2 || canje.status === 1)"
                                    [routerLink]="['../../supervisor/atender/canje', canje.id]"><i class="pi pi-pencil"
                                        style="color: slateblue"></i></a>
                            </td>
                            <td>
                                <a *ngIf="(canje.status === 3)"
                                    [routerLink]="['../../supervisor/vista/canje', canje.id]"><i class="pi pi-eye"
                                        style="color: slateblue"></i></a>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td colspan="5" class="text-center p-4">
                                <div class="flex flex-column align-items-center">
                                    <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                                    <span class="text-600 mt-2">No se encontraron canjes</span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            <p>No. Registros: {{totalItemsCanjes}}, Total paginas {{totalPaginasCanjes}}</p>
                            <p>Cantidad de canje pagados:{{canjesPagados}}</p>
                        </div>
                    </ng-template>
                </p-table>
                <div class="card flex justify-content-center">
                    <p-paginator (onPageChange)="onPageChangeCanjes($event)" [first]="currentPageCanjes.first"
                        [rows]="currentPageCanjes.rows" [totalRecords]="totalItemsCanjes"></p-paginator>
                </div>
            </section>
        </p-accordionTab>
    </p-accordion>
    <div class="mt-3">
        <p-button type="button" label="Regresar" (click)="regresar()" styleClass="p-button-sm"></p-button>
    </div>
</div>